import { useGGTheme } from 'hooks/theme/useGGTheme';

import s from './TextureSection.module.css';

type TProps = {
  children: React.ReactNode;
  title: string;
};

export const TextureSection = ({ children, title }: TProps) => {
  const { theme } = useGGTheme();
  const textPrimary = theme?.palette.textPrimary || '#000000';

  const mixBlendMode = textPrimary > '#888888' ? 'darken' : 'lighten';

  return (
    <section className={s.root}>
      <h2 className={s.title} style={{ mixBlendMode }}>
        {title}
      </h2>
      {children}
    </section>
  );
};
